<template>
	<div>
		<div class="details">
			<div class="details-left">
				<div class="details-left-tab">
					<div @click="tabClick(0)" :class="tabType==0 ? 'activt':''">竞赛信息</div>
					<div @click="tabClick(1)" :class="tabType==1 ? 'activt':''">通知公告</div>
					<div @click="tabClick(2)" :class="tabType==2 ? 'activt':''">相关下载</div>
					<div @click="tabClick(3)" :class="tabType==3 ? 'activt':''">讨论区</div>
				</div>
				<div class="details-left-body" v-if="tabType==0">
					<p class="title">{{info.name}}</p>
					<div class="navigationt">竞赛信息</div>
					<div class="richtext" v-html="info.details">
					
					</div>
				</div>
				<div class="details-left-body" v-if="tabType==1">
					
					<div class="richtext" >
						<el-table
						      :data="announcement"
						      style="width: 100%">
						     <el-table-column
						        prop="name"
						        label="标题"
						        width="180">
						      </el-table-column>
						      <el-table-column
						        prop="details"
						        label="详情">
						      </el-table-column>
						    </el-table>
					</div>
				</div>
				
				
				<div class="details-left-body" v-if="tabType==2">
					
					<div class="richtext" >
						<el-table
						      :data="file"
						      style="width: 100%">
						     <el-table-column
						        prop="name"
						        label="标题"
						        width="180">
						      </el-table-column>
						      <el-table-column
						        label="详情" 
								prop="name">
									<template slot-scope="scope">
									  <a :href="scope.row.upload | Ximgurl" target="_blank" download="2">点击下载
									  </a>
									</template>
							  </el-table-column>
							    
						    </el-table>
					</div>
				</div>
				
			</div>
			<div class="details-right">
				<div class="details-right-header">
					<div class="img">
						<img :src="sponsor.avatar | Ximgurl" />
						<div >
							<div class="da">{{sponsor.username}}</div>
							<div class="xiao">{{sponsor.brief}}</div>
						</div>
					</div>
					<!-- <div class="body">{{info.brief}}</div> -->
					<div class="top">
						<div class="top-div">
							<el-button  size="small" @click="signClick()" class="basg" icon="el-icon-link">参赛报名</el-button>
						
						</div>
						<div class="top-div">
							<el-button size="small" @click="exerciseClick()" icon="el-icon-edit">题型练习</el-button>
							<el-button @click="examinationClick()"  size="small" icon="el-icon-edit">进入考试</el-button>
						</div>
					
					</div>
					<div style="	border-bottom: 1px solid rgb(143 135 135); margin-top: 20px;"></div>
				</div>
				
				<div  class="details-right-body">
					<div class="details-right-body-div" >
						<div class="left">主办方</div>
						<div  class="right">{{sponsor.username}}</div>
					</div>
					<div class="details-right-body-div">
						<div class="left">参赛对象</div>
						<div  class="right">{{info.scope}}</div>
					</div>
					<div class="details-right-body-div">
						<div class="left">类型</div>
						<div  class="right">{{info.game_type==0 ? '个人': '团队'}}</div>
					</div>
					<div class="details-right-body-div">
						<div class="left">报名费</div>
						<div  class="right">{{info.entryfee}}元</div>
					</div>
					<div class="details-right-body-div">
						<div class="left">考试模式</div>
						<div  class="right"> {{info.pattern==0 ? '线上':'线下'}}</div>
					</div>
					<div class="details-right-body-div">
						<div class="left">报名时间</div>
						<div  class="right">{{info.apply_time}}</div>
						<p>{{info.apply_starttime | format_date}} 至 {{info.apply_endtime | format_date}}</p>
					</div>
					
					<div class="details-right-body-div">
						<div class="left">比赛时间</div>
						<div  class="right">{{info.game_Time}}</div>
						<p>{{info.game_starttime | format_date}} 至 {{info.game_endtime | format_date}}</p>
					</div>
					
					<div class="details-right-body-div">
						<div class="left">考试时间</div>
						<div  class="right">{{info.game_time}}min</div>
					</div>
					
					<div class="details-right-body-div">
						<div class="left">评奖</div>
						<div  class="right">{{info.prize
						}}</div>
					</div>
					
				</div>
			</div>
			
		</div>
		<div style="height: 60px;"></div>
		
		<FormDat :form="form" :bag="bag"  v-if="bag==1"   @childFn="parentFn"></FormDat>
		
		
	</div>
	
	
</template>

<script>
	import FormDat from './form'
	export default {
	    data() {
			return {
				bag   : 0,
				tabType : 0,
				formtype : '',
				info  : [],
				sponsor:[],
				announcement: [],
				file : [],
				type : '',
				form : [],
				formuser:[],
			
			}
		},
		components:{
			FormDat
		},
		created() {
			let that    = this;
			var  query = this.$route.query;
			
			if(query.id){
				that.$http('get','/api/v1/game/details',{'id':query.id}) .then(function (res) {
					that.info = res.data.info;	
					
					that.$http('get','/api/v1/merchant/details',{'id':that.info.merchant_id}) .then(function (res) {
						that.sponsor     = res.data.info;
					  
					});
				});
				that.$http('get','/api/v1/game/form_info',{'game_id':query.id}) .then(function (res) {
					that.form     = res.data.info;
					that.formtype = res.data.type;
					that.formuser = res.data.formuser;
				});
				that.$http('get','/api/v1/announcement/list',{'game_id':query.id}) .then(function (res) {
					that.announcement = res.data.list;	
						
				});
				that.$http('get','/api/v1/file/list',{'game_id':query.id}) .then(function (res) {
					that.file = res.data.list;	
					console.log(res);	
				});
			}
		},
		methods:{
			tabClick(e){
				if(e==3){
					this.$message.error('暂时无开放');return;
				}
				this.tabType = e;
			},
			examinationClick(){  //进入考试
				if(this.formuser.type==1){
					this.$message.error('你已经考试');return;
				}
				if(this.formtype==0){
					this.$message.error('正在审核中');return;
				}
				if(this.formtype==2){
					this.$message.error('拒绝报名');return;
				}
				if(this.formtype==3){
					this.$message.error('未报名');return;
				}
				this.$router.push('/topic/exam?id='+this.info.id);
			},
			exerciseClick(){  //练习
					if(this.formtype==0){
								this.$message.error('正在审核中');return;
							}
							if(this.formtype==2){
								this.$message.error('拒绝报名');return;
							}
							if(this.formtype==3){
								this.$message.error('未报名');return;
							}
				this.$router.push('/topic/exercise1?game_id='+this.info.id);
			},
			signClick(){  //报名
				if(this.formtype ==1){
					this.$message.error('你已经报过名了');return;
				}
				if(this.formtype ==2){
					this.$message.error('拒绝报名');return;
				}
				if(this.form==null){
					this.$message.error('暂不能报名');return;
				}
				this.bag = 1;
			},
			parentFn(payload) {
			    // childValue就是子组件传过来的值
				console.log(payload);
				this.bag = payload
			}
			
		}
		
	}	
</script>

<style lang="less">

	.details {
		margin-left: auto;
		margin-right: auto;
		width: 98%;
		min-height: 480px;
		display: flex;
		margin-top: 2rem;
		
		
		.details-left {
			flex: 3;
			
			border: 1px solid rgba(233, 233, 233, 1);
			border-radius: 10px;
			box-shadow: 0 0 5px #FFF0FF;
			.details-left-tab {
				display: flex;
				height: 60px;
				border-bottom: 1px solid  rgba(233, 233, 233, 1);
				line-height: 60px;
				font-weight: 600;
				font-size: 20px;
				color: #333333;
			
				div {
					padding-left: 10px;
					padding-right: 10px;
					width: 100px;
					text-align: center;
					
				}
			}
			.details-left-body {
				padding-left: 20px;
				.title {
					font-size: 18px;
					font-weight: 600;
				}
				.navigationt {
					width: 80px;
					padding-left: 6px;
					color: #666666;
					font-weight: 600;
					border-left: 4px solid #D9001B;
					font-size: 14px;
				}
				.richtext {
					margin-top: 20px;
					padding-left: 20px;
					padding-right: 20px;
				}
				
			}
			
		}
	
		.details-right {
			margin-left: 20px;
			flex: 1;
			border-radius: 10px;
			border: 1px solid rgba(233, 233, 233, 1);
			box-shadow: 0 0 5px #FFF0FF;
			min-height: 780px;
			
			.details-right-header {
				margin-top: 40px;
				.img {
					width: 80%;
					margin-left: auto;
					margin-right: auto;
					display: flex;
					img {
						width: 40px;
						height: 40px;
						display: block;
					}
					div {
						padding-left: 6px;
						.da {
							color: #333333;
							height: 26px;
							font-size: 16px;
						}
						.xiao {
							color: #999999;
							font-size: 8px;
						}
					}
				}
				.body {
					font-size: 8px;
					width: 90%;
					margin-right: auto;
					margin-left: auto;
					line-height: 24px;
					margin-top: 10px;
					text-align: center;
				}
				.top {
					width: 80%;
					margin-right: auto;
					margin-left: auto;
				
					.top-div {
						display: flex;
						margin-top: 10px;
					}
				}
			}
			.details-right-body {
				width: 80%;
				margin-left: auto;
				margin-right: auto;
				margin-top: 20px;
				.details-right-body-div {
					display: flex;
					flex-wrap: wrap;
					// line-height: 30px;
					// min-height: 18px;
					font-size: 12px;
					min-height: 40px;
					.left {
						// line-height: 30px;
						height: 18px;
						width: 80px;
						padding-left: 6px;
						color: #666666;
						font-weight: 600;
						border-left: 4px solid #D9001B;
						font-size: 14px;
					}
					.right {
						// line-height: 30px;
						// height: 30px;
					}
					
				}
			}
		}
		.activt:after{ content:""; width:6rem; height:3px; background-color: #D9001B; margin:-3px auto 0 auto; display:block; }
		
		.basg {
			background-color:  #D9001B;
			color: #FFFFFF;
		}
		
	}
</style>
